import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { LiquidDrop, PublicReviewPage, ReviewPageConfig, ReviewPageConfigSettings } from "./dtos";

const REVIEW_PAGE_CONFIG_SERVICE = `${Constants.API_URL}/bedrock/review_page_config`;

export class ReviewPageConfigServices {
  @scCatchServiceException()
  static async getConfig(): Promise<ReviewPageConfig> {
    const { data } = await axios.get<ReviewPageConfig>(REVIEW_PAGE_CONFIG_SERVICE);
    return data;
  }

  @scCatchServiceException(true)
  static async updateConfig(payload: ReviewPageConfigSettings): Promise<ReviewPageConfig> {
    const { data } = await axios.patch<ReviewPageConfig>(REVIEW_PAGE_CONFIG_SERVICE, payload);
    return data;
  }

  @scCatchServiceException()
  static async getLiquidVariables(): Promise<LiquidDrop> {
    const { data } = await axios.get<LiquidDrop>(`${REVIEW_PAGE_CONFIG_SERVICE}/liquid_variables`);
    return data;
  }

  @scCatchServiceException()
  static async getPreview(playerGuid: string, overrides: URLSearchParams): Promise<PublicReviewPage> {
    const { data } = await axios.get<PublicReviewPage>(
      `${REVIEW_PAGE_CONFIG_SERVICE}/preview/${encodeURIComponent(playerGuid)}`,
      {
        params: overrides,
      }
    );
    return data;
  }
}
